import React from 'react';

import styles from './PageSection.css';

const PageSection = ({ title, subtitle, hideTitle, children, quickLinks }) => (
    <React.Fragment>
        <div className="section-header">
            {!hideTitle && <h2>{title}</h2>}
            <div className="content">
                {subtitle && <h3 className="subtitle">{subtitle}</h3>}
                {quickLinks && (
                    <div className="quick-links">
                        {quickLinks.map(({ text, href, title: linkTitle }) => (
                            <a
                                key={`link-${text}-${linkTitle}-${href}`}
                                href={href}
                                title={title}
                            >
                                {text}
                            </a>
                        ))}
                    </div>
                )}
            </div>
        </div>
        {children}
        <style jsx>{styles}</style>
    </React.Fragment>
);

export default PageSection;
